import { useRef } from "react";
import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import USP from "@/components/landing/USP";
import Authority from "@/components/landing/Authority";
import BookPromo from "@/components/landing/BookPromo";
import SocialProof from "@/components/landing/SocialProof";
import Urgency from "@/components/landing/Urgency";
import LeadForm from "@/components/landing/LeadForm";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-[#0A1628] text-white font-sans" data-testid="landing-page">
      <Navigation onCtaClick={scrollToForm} />
      <main>
        <Hero onCtaClick={scrollToForm} />
        <Problem />
        <Solution onCtaClick={scrollToForm} />
        <USP />
        <Authority onCtaClick={scrollToForm} />
        <BookPromo />
        <SocialProof />
        <Urgency onCtaClick={scrollToForm} />
        <LeadForm formRef={formRef} />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
